import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from '@material-ui/core/Divider';
import {mixpanel} from "./App.js";

import {SoundPlayer} from './SoundPlayer.js';
import colors from './colors.js';

const useStyles = makeStyles(theme => ({
  doctorDetailContainer: {
    backgroundColor: colors.grey,
    color: colors.blue,
    height: '100%',
    width: theme.spacing(40),
    padding: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      width: "100vw",
    },
  },
  avatar: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: `1px solid ${colors.green}`,
  },
  entryList: {
    paddingTop: 0,
  },
  doctorDetailHeader: {
    display: 'flex',
    height: theme.spacing(8),
    paddingLeft: theme.spacing(1),
    backgroundColor: colors.grey,
    boxShadow: `0 0 0px`,
    borderBottom: `1px solid ${colors.darkgrey}`,
    zIndex: 1,
  },
  doctorDetailDiaryEntryListHeader: {
    margin: 0,
    fontSize: '16px',
    color: colors.blue,
    marginBottom: theme.spacing(1),
    borderBottom: `3px ${colors.blue}`,
  },
  doctorDetailBackArrowButton: {
    alignSelf: 'center',
    marginRight: theme.spacing(2),
    cursor: 'pointer',
    "&:active": {
      color: colors.darkgrey,
    }
  },
  doctorDetailTitle: {
    flexGrow: 1,
    alignSelf: "center",
    color: colors.blue,
    textAlign: "center",
    fontSize: "18px",
    marginRight: theme.spacing(2),
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "250px",
    flexGrow: 1,
  },
}));


export const DoctorDetail = ({selectedDoctor, onBack}) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.doctorDetailHeader}>
        <ArrowBackIcon
          className={classes.doctorDetailBackArrowButton}
          onClick={onBack}
        />
        <p className={classes.doctorDetailTitle}>
          {selectedDoctor?.name}, {selectedDoctor?.specialty}
        </p>
      </div>
      <div className={classes.doctorDetailContainer}>
        {selectedDoctor ? (
          <>
            <img
              variant="square"
              className={classes.avatar}
              src={'https:' + selectedDoctor.avatar?.fields?.file?.url}
              alt={'avatar'}
            />
            <p className={classes.doctorDetailDiaryEntryListHeader}>
              <bold><i>Diary entries</i></bold>
            </p>
            <Divider />
            <List className={classes.entryList}>
              {(selectedDoctor.diaryEntry || []).map(de => (
                <SoundPlayer
                  streamUrl={'https:' + de.fields.file.url}
                  title={de.fields.title}
                  onPlay={() => {
                    mixpanel.track("play_diary", {
                      title: de.fields.title,
                      name: selectedDoctor.name,
                      specialty: selectedDoctor.specialty,
                      city: selectedDoctor.city
                    });
                  }}
                  onPause={() => {
                    mixpanel.track("pause_diary", {
                      title: de.fields.title,
                      name: selectedDoctor.name,
                      specialty: selectedDoctor.specialty,
                      city: selectedDoctor.city
                    });
                  }}
                />
              ))}
            </List>
          </>
        ) : null}
      </div>
    </>
  );
};
